import { PieChart, Pie, Cell } from "recharts";
import { colorsArray } from "utils/constants";

export function CustomPieChart({ width, height, data, classes }: any) {
  const RADIAN = Math.PI / 180;

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }: any) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "middle"}
        dominantBaseline="central"
        className="text-xs"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <PieChart width={width} height={height} className={classes}>
      <Pie
        data={data}
        cx="50%"
        cy="50%"
        labelLine={false}
        label={renderCustomizedLabel}
        outerRadius={height / 2}
        fill="#8884d8"
        dataKey="value"
        minAngle={15}
      >
        {data.map((entry: any, index: any) => (
          <Cell key={`cell-${index}`} fill={colorsArray[index]} />
        ))}
      </Pie>
    </PieChart>
  );
}
